import { render } from "./threshold-config-dialog.vue?vue&type=template&id=3e71dd2b&scoped=true"
import script from "./threshold-config-dialog.vue?vue&type=script&lang=js"
export * from "./threshold-config-dialog.vue?vue&type=script&lang=js"

import "./threshold-config-dialog.vue?vue&type=style&index=0&id=3e71dd2b&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e71dd2b"]])

export default __exports__